import React, { Component } from "react";
import Button from "../reusable/components/Button.jsx";
import { Modal } from '@deere/ux.uxframe-react';

import Select from '../reusable/components/Select';
import baseurl from "../api-properties";

class AuditSummary extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            prosNumber: this.props.companyInfoObjDIV.prosNumber,
            prosSuppId: this.props.companyInfoObjDIV.prosSuppId,
            loginBy: this.props.loginByDiv,
            displayAuditModal: false,
            auditTypes: [],
            formValue: {
                auditTypeName: ""
            },
            formErrors: {
                auditTypeName: "", showError: false
            }
        };
        this.showAuditModal = this.showAuditModal.bind(this);
        this.hideAuditModal = this.hideAuditModal.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.addAudit = this.addAudit.bind(this);
        this.handleSubmitAuditBtn = this.handleSubmitAuditBtn.bind(this);
    }

    componentDidMount() {
        this.loadAuditDropDownList();
    }

    loadAuditDropDownList = () => {
        fetch(baseurl.AUDIT_API_URL + "audit/getAuditDefinations/isRequired/auditName?isRequired=true")
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                let auditList = data.map(result => { return { value: result.auditName, display: result.auditDescription } })
                this.setState({ auditTypes: [{ value: '', display: 'Select...' }].concat(auditList) });
            }).catch(error => {
                console.log(error);
            });
    }

    showAuditModal(e) {
        let fieldErrors = this.state.formErrors;
        fieldErrors.showError = false;
        fieldErrors.auditTypeName = "";
        this.setState({ formErrors: fieldErrors });

        let formValues = this.state.formValue;
        formValues.auditTypeName = "";
        this.setState({ formValue: formValues });

        this.setState({ displayAuditModal: true });
    }
    hideAuditModal(e) {
        this.setState({ displayAuditModal: false });
    }
    handleSubmitAuditBtn(e) {
        // e.preventDefault();
        let prosSuppId = this.state.prosSuppId;
        let prosNumber = this.state.prosNumber;
        let auditStatus = "P";
        let loginBy = this.state.loginBy;
        let auditNameVal = e.target.value;
        let userData = { "prosSuppId": prosSuppId, "prosNumber": prosNumber, "status": auditStatus, "createdBy": loginBy, "auditName": auditNameVal };
        fetch(baseurl.AUDIT_API_URL + "audit/updateAudits", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            this.props.loadAudit(prosSuppId, false);
        }).catch(error => {

        });
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(
            prevState => ({
                formValue: {
                    ...prevState.formValue,
                    [name]: value
                }
            })
        );
    }

    addAudit(e) {
        e.preventDefault();
        this.formError = this.validateOnAdd();
        if (this.formError) {
            this.saveAudit(e);
        }
    }
    validateOnAdd = () => {
        let fieldErrors = this.state.formErrors;
        let error = this.validationMessage();
        if (error) {
            fieldErrors.showError = true;
            this.setState({ formErrors: fieldErrors });
        } else {
            fieldErrors.showError = false;
            this.setState({ formErrors: fieldErrors });
        }
        return !error;
    }

    validationMessage = () => {
        let fieldErrors = this.state.formErrors;
        let existAuditList = this.props.auditInfoData;
        let isValid = false;
        fieldErrors.auditTypeName = "";

        if (this.state.formValue.auditTypeName.length <= 0) {
            fieldErrors.auditTypeName = "Audit Type is required field.";
            isValid = true;
        }

        if (!isValid) {
            existAuditList.map((auditObj, index) => {
                if (this.state.formValue.auditTypeName === auditObj.auditName) {
                    fieldErrors.auditTypeName = "Audit Type is already exist, please select another Audit.";
                    isValid = true;
                }
            })
        }
        return isValid;
    }

    saveAudit(e) {
        e.preventDefault();
        let status = "S";
        let userData = { "prosNumber": this.state.prosNumber, "validateAudit": false, "status": status, "auditName": this.state.formValue.auditTypeName, "createdBy": this.props.companyInfoObjDIV.loginBy, "result": status };
        fetch(baseurl.AUDIT_API_URL + "audit/saveAudits", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            response.json().then(data => {
                this.hideAuditModal();
                this.props.loadAudit(this.state.prosSuppId, false);
            });
        });
    }

    render() {
        return (
            <div>
                {(this.props.auditInfoData !== null && this.props.auditInfoData.length > 0) ?
                    Object.values(this.props.auditInfoData).map((audit, index) =>
                        <div class="row">
                            <div className="border-bottom col-sm-16" style={{ textAlign: 'left' }}>
                                <label>{audit.auditDescription}</label><br></br>
                                <span>
                                    {audit.status === "C" ?
                                        <span>Completed By <label>{audit.createdBy}</label> On {audit.createdDate}</span> :
                                        audit.status === "F" ? <span>Failed By <label>{audit.createdBy}</label> On {audit.createdDate}</span> :
                                            audit.status === "P" ? <span>In Progress</span> :
                                                audit.status === "S" ? <span>Yet to Submit</span> : null
                                    }
                                </span>
                            </div>
                            <div class="border-bottom col-sm-8" style={{ textAlign: '-webkit-right', paddingTop: '12px' }}>
                                {this.props.companyInfoObjDIV.status === 'A' || this.props.companyInfoObjDIV.status === 'D' || this.props.companyInfoObjDIV.status === 'N' ? null :
                                    <div>
                                        {audit.status === "C" ?
                                            <div style={{ textAlign: 'center', borderRadius: '3px', backgroundColor: 'green', color: 'white', width: '80px', height: '28px' }}>Pass</div> :
                                            audit.status === "F" ? <div style={{ textAlign: 'center', borderRadius: '3px', backgroundColor: '#C63213', color: 'white', width: '80px', height: '28px' }}>Fail</div> :
                                                audit.status === "P" ? null :
                                                    audit.status === "S" ? <span><Button type={"success"} value={audit.auditName} action={this.handleSubmitAuditBtn} title={"Submit Audit"} /></span> : null
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    )
                    : null
                }
                <br></br>
                {this.props.companyInfoObjDIV.status === 'A' || this.props.companyInfoObjDIV.status === 'D' || this.props.companyInfoObjDIV.status === 'N' ? null :
                    <div class="row">
                        <div class="col-sm-24" style={{ textAlign: 'right' }}>
                            <Button type={"warning"} action={this.showAuditModal} title={"+Add Audit"} />{" "}
                        </div>
                    </div>
                }
                <Modal show={this.state.displayAuditModal} class="modal-footer">
                    <Modal.Header>
                        <h5 class="modal-title">Add Audit</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <p class="uxf-alert-title">
                            <Select
                                title={"Audit Type"}
                                name={"auditTypeName"}
                                tabIndex="8"
                                options={this.state.auditTypes}
                                value={this.props.auditTypeName}
                                handleChange={this.handleInput}
                                defaultValue=""
                            />{" "}<span className="error">{this.state.formErrors.auditTypeName}</span>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="secondary" action={this.hideAuditModal} title="Cancel"></Button>&nbsp;&nbsp;
                        <Button type="warning" action={this.addAudit} title="Add"></Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
export default AuditSummary;